<div class="inline-panel">

  <div class="summary-card">
   <div *ngIf="isLoadingDetails" style="display: flex; justify-content: center; align-items: center; padding: 2rem;">
      <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
    </div>

    <div class="summary-content" *ngIf="!isLoadingDetails && inspectionDetails">
      <div class="summary-row">
        <div class="summary-item">
          <span class="label">Requester:</span>
          <span class="value">{{ inspectionDetails?.requestorName || '' }}</span>
        </div>
        <div class="summary-item">
          <span class="label">Requested Date & Time:</span>
          <span class="value">
            <ng-container *ngIf="inspectionDetails?.activityRequestedOn">
              {{ inspectionDetails.activityRequestedOn | date: 'MM/dd/yyyy' }}
              <ng-container *ngIf="inspectionDetails.activityRequestedHasTime"> | {{ inspectionDetails.activityRequestedOn | date: 'shortTime'}}</ng-container>
              <ng-container *ngIf="!inspectionDetails.activityRequestedHasTime && inspectionDetails.activityRequestedAmPm"> | 00:00 {{ inspectionDetails.activityRequestedAmPm }}</ng-container>
            </ng-container>
          </span>
        </div>
        <!-- <div class="summary-item">
        </div>
        <div class="summary-item status-col">
        </div> -->
      </div>

      <div class="summary-row">
        <div class="summary-item">
          <span class="label">Requestor Phone Number:</span>
          <span class="value">{{ inspectionDetails?.requestorPhoneNumber || '' }}</span>
        </div>
        <div class="summary-item">
          <span class="label">Scheduled On:</span>
          <span class="value">
            {{ (inspectionDetails?.activityScheduledOn || inspectionDetails?.scheduledOn || inspectionDetails?.scheduledDate || row?.scheduledOn) | date: 'MM/dd/yyyy' }}
            <ng-container *ngIf="inspectionDetails?.activityScheduledOn || inspectionDetails?.scheduledOn || inspectionDetails?.scheduledDate || row?.scheduledOn">
              | {{ (inspectionDetails?.activityScheduledOn || inspectionDetails?.scheduledOn || inspectionDetails?.scheduledDate || row?.scheduledOn) | date: 'shortTime' }}
            </ng-container>
          </span>
        </div>
      </div>

      <div class="summary-row">
        <div class="summary-item">
          <span class="label">Requestor Email:</span>
          <span class="value">{{ inspectionDetails?.requestorEmail || '' }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="tabs-row mui-tabs-wrapper">
    <mat-tab-group
      [selectedIndex]="getActiveTabIndex()"
      (selectedIndexChange)="onTabIndexChange($event)"
      class="custom-tabs"
      [disableRipple]="true"
      [mat-stretch-tabs]="false"
      color="transparent"
      backgroundColor="transparent"
      style="--mat-tab-divider-height: 0px; --mat-tab-divider-color: transparent;"
    >
      @for (tab of visibleTabs; track tab.id) {
        @if (tab.id !== 'LinktoApplication' || inspectionDetails?.noSchedule) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div
                class="janus-category-list-button"
                [class.janus-active-category-list-button]="activeTab === tab.id"
              >
                <wm-common-button
                  [data]="getTabButtonData(tab)">
                </wm-common-button>
              </div>
            </ng-template>
          </mat-tab>
        }
      }
    </mat-tab-group>
  </div>

  <div class="tab-content-container" style="position: relative; min-height: 150px;">

    <div *ngIf="isActivityLoading" style="display: flex; justify-content: center; align-items: center; padding: 2rem;">
      <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
    </div>

    <ng-container *ngIf="!isActivityLoading">
      <app-inspections-documents
      *ngIf="activeTab === 'documents'"
      [row]="row"
      [documents]="inspectionDocuments"
      (added)="onInspectionDocsAdded($event)"
      (deleted)="onInspectionDocDeleted($event)"
      (saved)="onInspectionDocSaved($event)">
    </app-inspections-documents>

      <app-schedule-inspection
         *ngIf="activeTab === 'schedule'"
        [activity]="currentActivity"
        (confirm)="handleScheduleSubmit($event)"
        (cancel)="closeExpansion()">
      </app-schedule-inspection>

      <app-complete-inspection
         *ngIf="activeTab === 'complete'"
        [activity]="currentActivity"
        (confirm)="handleCompleteSubmit($event)"
        (cancel)="closeExpansion()">
      </app-complete-inspection>

      <app-inspections-notes
        *ngIf="activeTab === 'notes'"
        [applicationId]="inspectionDetails?.inspectionApplicationId"
        [applicationNumber]="row?.appNo">
      </app-inspections-notes>

      <app-link-to-application
        *ngIf="activeTab === 'LinktoApplication' && inspectionDetails?.noSchedule"
        [applicationId]="inspectionDetails?.inspectionApplicationId"
        [applicationNumber]="row?.appNo"
        [applicationName]="row?.appType"
        [inspectionId]="row?.id"
      >
      </app-link-to-application>

      <ng-container *ngIf="activeTab === 'view-summary'">
        <!-- Wraps the component in the grey card design -->
        <div class="view-summary-card">
          <div class="view-summary-insidecard">

            <ng-container *ngIf="resolvedAppId; else viewSummaryLoader">
              <!-- We strictly pass ONLY [appId] to match call-workflow-input and prevent the 400 Bad Request crash -->
              <wm-application-summary
                [appId]="resolvedAppId"
                [renderPrintMode]="true"
                [bgWhite]="false"
                [showPrint]="false"
                [editApplicationJanusView]="false"
                [includeInProgressActivities]="false">
              </wm-application-summary>
            </ng-container>

            <ng-template #viewSummaryLoader>
              <div style="display: flex; justify-content: center; align-items: center; padding: 2rem;">
                <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
              </div>
            </ng-template>

          </div>
        </div>
      </ng-container>

    </ng-container>

  </div>

</div>
